import { useQuery } from '@tanstack/react-query'
import { fetchShipments } from './fetchShipments'

/**
 * Fetch the shipments data
 */
export const useShipments = () => {
  const { data } = useQuery({
    queryKey: ['shipments'],
    queryFn: () => fetchShipments(),
    enabled: true,
  })

  return { data }
}
